<template>
  <div class="container-fluid">
    <div class="row justify-content-around">
      <div class="col-xl-4 headImg">
        <gene-info-carousel></gene-info-carousel>
      </div>
      <div class="col-xl-7">
        <div class="row">
          <gene-info-card></gene-info-card>
        </div>
        <div class="row">
          <div class="col-lg-5">
            <chrom-ass-table class="infoTable"></chrom-ass-table>
          </div>
          <div class="col-lg-7">
            <chrom-type-table class="infoTable"></chrom-type-table>
          </div>
        </div>
      </div>
    </div>
    <!-- <hr style="postion: relative; margin-top: 5rem;">
    <div class="hrTitle"><b-icon icon="pin-map"></b-icon><b> Species Distribution </b></div>
    <tree-dis-map></tree-dis-map> -->
    <hr style="postion: relative; margin-top: 5rem;">
    <div class="hrTitle"><b-icon icon="sliders"></b-icon><b> EpiGenome Browser</b></div>
    <gene-browser></gene-browser>
  </div>
</template>

<script>
import ChromAssTable from '../Table/ChromAssTable.vue'
import ChromTypeTable from '../Table/ChromTypeTable.vue'

import GeneInfoCard from './GeneInfoCard.vue'
import GeneInfoCarousel from './GeneInfoCarousel.vue'

// import TreeDisMap from '../Map/treeDisMap.vue'
import GeneBrowser from '../Browser/GeneBrowser.vue'

export default {
  components: { 
    GeneInfoCard, 
    GeneInfoCarousel,
    ChromAssTable,
    ChromTypeTable,
    // TreeDisMap,
    GeneBrowser
  }
}
</script>

<style>
  .carousel-caption {
    color: DodgerBlue
  }
  .carousel-indicators {
    background-color: #bdbdbd44;
  }
  .infoTable {
    margin-top: 3rem;
    text-align: center;
  }
  .hrTitle {
    position: relative; 
    left: 44%; 
    top: -2.3rem; 
    height: 5rem; 
    width: 17rem; 
    text-align: center; 
    background-color: white; 
    font-size: 1.55rem; 
  }
</style>